module.exports = __webpack_public_path__ + "static/media/ios_3_600.3fe56007.png";